'use strict';

angular
    .module('app')
    .filter('formatDateTimeObject', function() {
        return function(date, format) {
            var m = moment.utc(date.date);
            return m.format(format);
        };
    })
    .filter('formatDateTime', function() {
        return function(date, format) {
            var m = moment.utc(date);
            return m.format(format);
        };
    })
    .filter('momentTime', function() {
        return function(date, format, tz) {
            var m = moment(date);
            if (tz !== void 0) {
                m.tz(tz);
            }
            return m.format(format);
        };
    });
